import React from 'react'
import Modal from '@mui/material/Modal';
import { tokens } from "../../theme";
import { Box, useTheme, Typography, Divider } from "@mui/material";
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InfoModal = ({ homework, open, handleClose, StyledTableCell, StyledTableRow }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: colors.primary[750],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    // Show ALL students with their status (on-time / late / not submitted), not just
    // non-submitters — otherwise a row where everyone submitted (or took an exam late)
    // shows an empty modal. Excluded students are dropped, mirroring the row chips.
    const exclude = homework.exclude_student ? homework.exclude_student.split('|') : [];
    const rows = [
        ...(homework.studentsWhoSubmitted || []).map((s) => ({ ...s, _status: "Submitted", _color: "success" })),
        ...(homework.lateSubmissionStudents || []).map((s) => ({ ...s, _status: "Late", _color: "warning" })),
        ...(homework.studentsWhoDidNotSubmit || []).map((s) => ({ ...s, _status: "Not submitted", _color: "default" })),
    ].filter((s) => !exclude.includes(String(s.id)));

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <InfoOutlinedIcon fontSize='large' />
                <Typography id="modal-modal-title" variant="h3" fontWeight="bold">
                    Student Info
                </Typography>
            </Box>
            <Divider sx={{ mt: 2 }} />
            <Typography component="div" id="modal-modal-description" sx={{ mt: 2 }}>
                <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
                    <Table aria-label="simple table">
                        <TableHead><StyledTableRow>
                            <StyledTableCell style={{ width: "32%" }}>Name</StyledTableCell>
                            <StyledTableCell style={{ width: "16%" }}>Status</StyledTableCell>
                            <StyledTableCell style={{ width: "26%" }}>Phone</StyledTableCell>
                            <StyledTableCell style={{ width: "26%" }}>Parent's Phone</StyledTableCell>
                        </StyledTableRow></TableHead>
                        <TableBody>
                            {rows.length === 0 ? (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={4}>No students for this item.</StyledTableCell>
                                </StyledTableRow>
                            ) : rows.map((student, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell style={{ width: "32%" }}>{student.name}</StyledTableCell>
                                    <StyledTableCell style={{ width: "16%" }}>
                                        <Chip size="small" color={student._color} label={student._status} />
                                    </StyledTableCell>
                                    <StyledTableCell style={{ width: "26%" }}>{student.phone}</StyledTableCell>
                                    <StyledTableCell style={{ width: "26%" }}>{student.parent_phone}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Typography>
            </Box>
        </Modal>
    )
}

export default InfoModal